const helpers = {
  goto(that, refName) {
    var element = that.$refs[refName].$el;
    var top = element.offsetTop;
    window.scrollTo(0, top);
  },
};
export default helpers;
